var exports = {
  "full_address": "x61f99309--ec6ec5--full_address",
  "highway": "x61f99309--ec6ec5--highway",
  "highway-icon": "x61f99309--ec6ec5--highway-icon",
};

module.exports = exports;
